import { Stack, Tooltip, Typography, TypographyTypeMap } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Icon as IconType } from '@tabler/icons-react';

export function RenderStringWithIcon({
  value,
  Icon,
  color,
  tooltip,
  typographyVariant,
}: {
  value: string;
  Icon: IconType;
  color:
    | 'warning'
    | 'success'
    | 'error'
    | 'info'
    | 'primary'
    | 'secondary'
    | 'grey';
  tooltip: string;
  typographyVariant?: TypographyTypeMap['props']['variant'];
}) {
  const theme = useTheme();
  const colorMap: { [key: string]: string } = {
    warning: theme.palette.warning.main,
    success: theme.palette.success.main,
    error: theme.palette.error.main,
    info: theme.palette.info.main,
    primary: theme.palette.primary.main,
    secondary: theme.palette.secondary.main,
    grey: theme.palette.grey[500],
  };
  return (
    <Tooltip placement="top" title={tooltip || ''}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="flex-start"
        spacing={0.5}
      >
        <Icon color={colorMap[color]} />
        <Typography variant={typographyVariant} color={colorMap[color]}>
          {value}
        </Typography>
      </Stack>
    </Tooltip>
  );
}
